import { DragVerticalIcon } from '@carboncopyco/icons';
import { ColorHex, Paper } from '@carboncopyco/ui';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type React from 'react';
import { iconByAssetType } from '../consts';
import type { PlaybookAssetSource } from '../types';

type RowWrapperProps<T> = {
  children: React.ReactNode;
  entityType: PlaybookAssetSource;
  asset: T;
};

export const DraggableRow = <T extends { assetId: string }>({
  children,
  entityType,
  asset,
}: RowWrapperProps<T>) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: asset.assetId,
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <li
      data-ds-id="draggable-row"
      style={style}
      ref={setNodeRef}
      className="group hover:shadow-ds-md hover:cursor-pointer rounded-lg"
      {...listeners}
      {...attributes}
    >
      <div>
        <Paper
          radius
          border="ds-regular"
          padding="sm"
        >
          <div className="flex items-center justify-between gap-2.5">
            <div className="flex items-center gap-2.5">
              <div className="shrink-0">
                <DragVerticalIcon color={ColorHex.primary} />
              </div>
              <div
                className="shrink-0"
                aria-label={entityType}
              >
                {iconByAssetType[entityType]}
              </div>
            </div>
            {children}
          </div>
        </Paper>
      </div>
    </li>
  );
};
